module.exports = ".go-back-btn {\n  position: absolute;\n  bottom: 25px; }\n\n:host {\n  text-align: center; }\n\n.dynamic-form {\n  width: 600px; }\n"